import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "echarts-base__empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SectionTitle = _resolveComponent("SectionTitle")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["echarts-base", { 'echarts-base--show-background': _ctx.getIsShowBackground }])
  }, [
    (_ctx.titleConfig.text)
      ? (_openBlock(), _createBlock(_component_SectionTitle, {
          key: 0,
          class: "echarts-base__header",
          text: _ctx.titleConfig.text,
          level: _ctx.titleConfig.level,
          tooltipContent: _ctx.titleConfig.tooltipContent,
          mode: _ctx.titleConfig.mode
        }, null, 8, ["text", "level", "tooltipContent", "mode"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      style: _normalizeStyle({ height: _ctx.getChartHeightPx, width: _ctx.getChartWidthPx })
    }, [
      (_ctx.isEmpty)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.emptyMessage), 1))
        : _renderSlot(_ctx.$slots, "default", { key: 1 }, undefined, true)
    ], 4)
  ], 2))
}